import { useEffect } from 'react';

import { setAgentVocabulary } from '../utils/install-agent-vocabulary';
import { useBobcatFlag } from './use-bobcat-flag';

/**
 * Project Bobcat, Proposal 1 — apply the Agent vocabulary when its flag is on.
 *
 * Mounted once, at the router root. The overlay is installed AFTER
 * LaunchDarkly answers rather than at i18n init, because `initI18n` is awaited
 * in `main.tsx` before the flag is known — so gating at init would read an
 * unanswered flag and always resolve to off.
 *
 * `pending` and `denied` both leave the shipped copy alone; only `allowed`
 * installs the overlay. Flipping the flag off mid-session restores the original
 * strings from the snapshot rather than needing a reload.
 */
export const useAgentVocabulary = (): void => {
  const access = useBobcatFlag('fiveStageNav');

  useEffect(() => {
    setAgentVocabulary(access === 'allowed');
  }, [access]);
};
